import React, { useEffect, useState } from 'react'
import { passReset, requestAccountReset } from './index01';
import { useParams } from 'react-router-dom';
import { messageDisplay } from '../Auth/Util';
import Header from '../Component/Header';
import Footer from '../Component/Footer';
import { CircularProgress } from 'react-loader-spinner';

const VendorForgot = () => {


const [email, setEmail] = useState("");
const [loading, setLoading] = useState(false);


const  submitAll = async (email) => {
 if(email.length > 0 ){
     setLoading(true);
       let wait = await requestAccountReset(email)
        if(wait){
            setLoading(false);
            setEmail("")
            messageDisplay(wait,0);
         }
        }else{
          messageDisplay("Invalid email",1);
   }
}
  return <>
        <Header/>
        <div class="bg-white text-primary dark:text-gray-800 mt-0 lg:mt-12">
            <div class="min-h-screen flex flex-col relative overflow-x-hidden">

            <main class="flex-1 flex items-center justify-center p-4 md:p-8">
                <div class="w-full max-w-[480px] flex flex-col p-5 shadow-lg">

                    <div class="bg-background-light/95 rounded-xl shadow-sm border border-gray-100 mt-8 p-6 md:p-8">
                        <div class="mb-8">
                        <h1 class="text-slate-700 text-[28px] md:text-[32px] font-bold leading-tight mb-3">Forgot password</h1>
                    </div>

                    <div class="flex flex-col gap-6">
                      <div class="flex flex-col gap-2">
                        <label class="text-slate-500 text-sm font-medium leading-normal">Email</label>
                        <div class="relative flex items-center">
                        <input  class="w-full rounded-lg border border-gray-200  bg-white  h-12 px-4 text-base text-primary  placeholder:text-gray-400" placeholder="Enter email address"  onChange={(e) => setEmail(e.target.value)}  value={email}/>
                        </div>
                        </div>
                        <button  onClick={(e) => submitAll(email)} class="w-full bg-blue-600 hover:bg-black/90 hover:bg-slate-200  text-white font-bold h-12 rounded-lg flex items-center justify-center gap-2 mt-2 shadow-sm hover:shadow-md">
                           {loading ? <CircularProgress width={20} height={20} color='#ffffff' /> :
                            <div className='flex justify-center text-center align-middle'>
                                <span>Send</span> &nbsp;
                                <span class="material-symbols-outlined text-[18px] self-center">arrow_forward</span>
                          </div>}
                        </button>
                    </div>
                </div>
             </div>
            </main>
        </div>
     </div>  
    <Footer/>
  </>
}

export default VendorForgot
